import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane} from 'reactstrap';
import PropTypes from 'prop-types';
import {formatarData} from "../../../../utils/formatar";
import _ from 'lodash';
import DetalhamentoHistoricoStore from "../stores/DetalhamentoHistoricoStore";
import classnames from 'classnames';
import FontAwesome from "react-fontawesome";

@inject("store")
@observer
export class DetalhamentoHistorico extends Component {

    static propTypes = {
        controller: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.controller = new DetalhamentoHistoricoStore();
    }

    traduzAcaoFluxo(acao) {
        let map = {
            "APPROVE": "aprovou",
            "AJUSTE": "demandou ajustes",
            "REJECT": "rejeitou",
            "ENVIAR": "enviou",
            "REIVINDICAR": "reivindicou",
            "CONFIRMAR_ALOCACAO": "confirmou alocação",
            "CANCELAR": "cancelou",
            "CANCELAR_TIMESHEET": "cancelou timesheet",
            "DESISTIR": "desistiu",
            "CONFIRMAR_CONTRATACAO": "confirmou contratação",
            "ENVIAR_APROVACAO": "enviou para aprovação",
            "FORCE_APPROVE": "forçou aprovação",
            "CONFIRMAR_MIGRACAO": "confirmou migração",
            "REAJUSTE_PISO": "reajustou salário-base"
        };
        if (map[acao]) return map[acao];
        else return "";
    }

    traduzTipoFluxo(tipo) {
        let map = {
            "GloboMOTSolicitacaoEtt":               "Contratação",
            "GloboMOTSolicitacaoMOT":               "Solicitação de Contratação",
            "GloboMOTSolicitacaoProrrogacao":       "Solicitação de Prorrogação",
            "SolicitacaoProrrogacao":               "Solicitação de Prorrogação",
            "GloboMOTSolicitacaoTerminoAntecipado": "Solicitação de Término Antecipado",
            "SolicitacaoTerminoAntecipado":         "Solicitação de Término Antecipado",
            "GloboMOTSubstituicao":                 "Solicitação de Substituição",
            "GloboMOTHoraExtra":                    "Horas trabalhadas",
            "GloboMOTMigracaoProduto":              "Migrar alocação"
        };
        if (map[tipo]) return map[tipo];
        else return "";
    }

    marcarTarefaAtual(tarefasFluxo, atual){
        tarefasFluxo.map( function(atual, tarefa) {
            if(atual.nomeTarefa.localeCompare(this.traduzNomeTarefaFluxo(tarefa.nomeTarefa), 'en', { sensitivity: 'base' }) === 0 ) {
                tarefa.nomeUsuarioResponsavel = atual.nomeUsuarioResponsavel;
                tarefa.tarefaAtual = true;
                tarefa.historico = undefined;
            }
        } .bind(this, atual) );
        return tarefasFluxo;
    }

    traduzNomeTarefaFluxo(tarefa) {
        let map = {
            "HT_SolicitacaoContratacao":                "Ajustar solicitação",
            "HT_AvaliacaoSolicitacaoEtt":               "Avaliar solicitação (ETT)",
            "HT_AvaliacaoSolicitacaoContratacao":       "Avaliar solicitação (Gestor da área solicitante)",
            "HT_AvaliacaoExtraSolicitacaoContratacao":  "Avaliar solicitação (Avaliador extra)",
            "HT_AvaliacaoSolicitacaoNGFT":              "Avaliar solicitação (NGFT)",
            "HT_AvaliacaoSolicitacaoDiretor":           "Avaliar solicitação (Diretor Solicitante)",
            "HT_AvaliacaoSolicitacaoGestorARDebito":    "Avaliar solicitação (Gestor centro de custo Débito)",
            "HT_AvaliacaoSolicitacaoRTS":               "Avaliar solicitação (RTS)",
            "HT_AvaliacaoSolicitacaoRemuneracao":       "Avaliar solicitação (Remuneração)",
            "HT_AvaliacaoSolicitacaoDCCH":              "Avaliar solicitação (DCCH)",

            "HT_ReivindicarConfirmarIndicado":          "",
            "HT_ReivindicarConfirmar":                  "Reivindicar alocação",
            "HT_ConfirmarContratacaoETT":               "Confirmar contratação (ETT)",
            "HT_ConfirmarAlocacao":                     "Confirmar alocação",
            "HT_AvaliarSolicitacaoRts":                 "Avaliar solicitação (RTS)",
            "HT_AvaliarSolicitacaoDnc":                 "Avaliar solicitação (DNC)",
            "HT_AvaliarSolicitacaoGestorSolicitante":   "Avaliar solicitação (Gestor da área solicitante)",
            "HT_AvaliarSolicitacaoRemuneracao":         "Avaliar solicitação (Remuneração)",
            "HT_AvaliarSolicitacaoGestorARDebito":      "Avaliar solicitação (Gestor centro de custo Débito)",
            "HT_ConfirmarContratacaoGestorSolicitante": "Confirmar contratação (Gestor da área solicitante)",

            "HT_AvaliacaoSolicitacao":                  "Avaliar solicitação (Gestor da área solicitante)",
            "HT_AvaliacaoExtraSolicitacao":             "Avaliar solicitação (Avaliador extra)",

            "HT_AvaliacaoSolicitacaoGestor":            "Avaliar solicitação (Gestor da área solicitante)",

            "HT_AvaliarSolicitacaoGestor":              "Avaliar solicitação (Gestor da área solicitante)",
            "HT_AvaliarSolicitacaoDiretor":             "Avaliar solicitação (Diretor da área solicitante)",
            "HT_ETTInformaRecurso":                     "Confirmar substituição (ETT)",

            "HT_AvaliarHorasExtrasGestor":              "Avaliar lançamento de horas (Gestor da área solicitante)",
            "HT_AjustarHorasExtrasETT":                 "Ajustar lançamento de horas (ETT)",
            "HT_LancarHorasExtrasETT":                  "Lançar horas (ETT)"
        };
        if (map[tarefa]) return map[tarefa];
        else return "";
    }

    render() {

        let comentarios = _.get(this.props.controller, "comentarios", "") ;
        let tarefasFluxo = _.get(this.props.controller, "tarefasFluxo", "") ;
        let tarefasFluxoComDadosHistorico = this.controller.copiarResponsavel(comentarios, tarefasFluxo);
        let atual = tarefasFluxoComDadosHistorico.pop();
        tarefasFluxoComDadosHistorico = this.marcarTarefaAtual(tarefasFluxoComDadosHistorico, atual);
        tarefasFluxoComDadosHistorico = this.controller.removerTarefasSemUsuario(tarefasFluxoComDadosHistorico);
        tarefasFluxoComDadosHistorico = this.controller.removerTarefasNaoRealizadas(tarefasFluxoComDadosHistorico, atual);

        return (
            <div>
                <Nav tabs className={`mt-3`}>
                    {comentarios.length > 0 &&
                    <NavItem>
                        <NavLink onClick={() => { this.controller.toggle('1'); }}
                                 className={classnames({ active: this.controller.activeTab === '1' })} >
                            Histórico
                        </NavLink>
                    </NavItem>
                    }
                    {tarefasFluxo .length > 0 &&
                    <NavItem>
                        <NavLink onClick={() => { this.controller.toggle('2'); }}
                                 className={classnames({ active: this.controller.activeTab === '2' })} >
                            Progresso
                        </NavLink>
                    </NavItem>
                    }
                </Nav>
                <TabContent activeTab={this.controller.activeTab} className={`mt-3`}>
                    <TabPane tabId="1">
                        {
                            comentarios.map(
                                (comentario, i) =>
                                    <Row key={i}>
                                        <Col xs={12} md={12}>
                                            <FormGroup>
                                                <div>
                                                    <div>
                                                        {formatarData(_.get(comentario, "dataComentario", ""))}
                                                        {' – '}
                                                        <span>{this.traduzTipoFluxo(_.get(comentario, "tipoFluxo", ""))}</span>
                                                        {_.get(comentario, "nomeTarefa", "") &&
                                                        <span>
                                                        {' – '}{this.traduzNomeTarefaFluxo(_.get(comentario, "nomeTarefa", ""))}
                                                        </span>
                                                        }
                                                        {' – '}
                                                        <span className="history-actor"> {_.get(comentario, "nomeUsuarioResponsavel", "")}</span>
                                                        {' '}
                                                        <span>{this.traduzAcaoFluxo(_.get(comentario, "acao", ""))}</span>
                                                    </div>
                                                    {_.get(comentario, "observacao", "") &&
                                                    <div className="history-item">
                                                        <span className="obs">{_.get(comentario, "observacao", "")}</span>
                                                    </div>
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                            )
                        }
                    </TabPane>
                    <TabPane tabId="2">
                        { tarefasFluxoComDadosHistorico.length > 0 &&
                            <table>
                                <tr>
                                    <th className={"text-center p-2"}>Tarefa</th>
                                    <th className={"text-center p-2"}>Responsável</th>
                                    <th className={"text-center p-2"}>Situação</th>
                                </tr>
                                {
                                    tarefasFluxoComDadosHistorico.map(
                                    (tarefaFluxo) =>
                                        <tr>
                                            <td className={"p-2"} style = {{'word-break': 'break-all'}}>{this.traduzNomeTarefaFluxo(_.get(tarefaFluxo, "nomeTarefa", ""))}</td>
                                            <td className={"p-2"} style = {{'word-break': 'break-all'}}>{_.get(tarefaFluxo, "nomeUsuarioResponsavel", "")}</td>
                                            <td className={"text-center p-2"} style = {{'word-break': 'break-all'}}>
                                                {_.get(tarefaFluxo, "historico", "") &&
                                                <FontAwesome className={"ml-2 fa-2x text-success"} name="check"/>
                                                }
                                                {_.get(tarefaFluxo, "tarefaAtual", "") &&
                                                <FontAwesome className={"ml-2 fa-2x text-primary"} name="map-marker"/>
                                                }
                                            </td>
                                        </tr>
                                    )
                                }
                            </table>
                        }
                    </TabPane>
                </TabContent>
            </div>
        )
    }
}